// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ede2cc13","239":"2b17afd9","455":"6dc5a256"}[chunkId] + ".chunk.js";
};